import React from 'react';
import { PieChart as PieChartRe, Pie, Sector, Cell } from 'recharts';
import { useTheme } from '@mui/material/styles';

export const PieChartGetColor = (p, a) => {
  const theme = useTheme();

  const integer = parseInt(p.replace('%', ''), 10);
  if (integer === 100) {
    return theme.custom.positive;
  }
  if (integer >= a + 5) {
    return theme.custom.positive;
  }
  if (integer < a + 5 && integer >= a - 5) {
    return theme.custom.neutral;
  }
  return theme.custom.negative;
};

export const PieChart = React.memo(({ basicData, percentage, average }) => {
  const theme = useTheme();
  const floatPercentage = parseFloat(basicData.percentage);
  let rest = 100 - floatPercentage;
  rest = parseFloat(rest.toFixed(2));

  const data = [
    {
      name: basicData.name,
      value: floatPercentage,
      color: PieChartGetColor(percentage, average)
    },
    { name: 'Other', value: rest, color: theme.custom.chartNeutral }
  ];

  const renderActiveShape = props => {
    const { cx, cy, innerRadius, outerRadius, fill, percent } = props;
    const textAnchor = 'end';
    const longitud = `${parseInt(percent * 100)}%`.length;
    
    let positionX;
    switch (longitud) {
      case 2:
        positionX = 110;
        break;
      case 3:
        positionX = 116;
        break;
      case 4:
        positionX = 120;
        break;
      default:
        positionX = 123;
        break;
    }

    return (
      <g>
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={90}
          endAngle={-360}
          fill={fill}
        />
        <text
          x={positionX}
          y={42}
          dy={18}
          textAnchor={textAnchor}
          fill="#000000"
          style={{ fontSize: 14 }}
        >
          {`${parseInt(percent * 100)}%`}
        </text>
      </g>
    );
  };

  return (
    <PieChartRe width={200} height={110}>
      <Pie
        activeIndex={0}
        activeShape={renderActiveShape}
        data={data}
        cx={95}
        cy={50}
        innerRadius={30}
        outerRadius={45}
        startAngle={90}
        endAngle={-360}
        fill="#8884d8"
        dataKey="value"
        nameKey="name"
      >
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={entry.color} />
        ))}
      </Pie>
    </PieChartRe>
  );
});
